import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const EditCategorySlice = createSlice({
    name: "editCategory",
    initialState,
    reducers: {
        editCategoryRequest(state) {
            state.loading = true;
        },
        editCategoryRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        editCategoryRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        editCategoryStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    editCategoryRequest,
    editCategoryRequestSuccess,
    editCategoryRequestError,
    editCategoryStateReset,
} = EditCategorySlice.actions;

export default EditCategorySlice.reducer;